import { checkDataIsEmpty } from "../../utils/form";
import _ from "lodash";
import { formatDate2, compareAscDate } from '../../utils/date';

export const WORK_DATA = {
  account_id: null,
  start_date: null,
  end_date: null,
}

export const WORK_VALIDATE_RULE = {
  account_id: {
    field: 'account_id',
    errorMsg: '請輸入廣告帳號編號',
    required: true
  },
  start_date: {
    field: 'start_date',
    errorMsg: '請輸入資料開始日期',
    errorMsg_check: '開始日期不得大於結束日期',
    required: true
  },
  end_date: {
    field: 'end_date',
    errorMsg: '請輸入資料結束日期',
    required: true
  },
}

export const validateForm = (data) => {
  let isError = false;
  const errorMsg = {};

  const startDate = data.start_date ? formatDate2(data.start_date) : null;
  const endDate = data.end_date ? formatDate2(data.end_date) : null;

  const updateData = {
    account_id: data.account_id,
    start_date: startDate,
    end_date: endDate
  }

  Object.entries(WORK_VALIDATE_RULE).forEach(el => {
    const currentValue = _.get(updateData, el[1].field);
    const currentIsError = checkDataIsEmpty(currentValue);

    let showErrorMsg;

    if (el[1].required === true) {
      showErrorMsg = currentIsError;
      errorMsg[el[0]] = currentIsError;
    } else {
      showErrorMsg = false;
      errorMsg[el[0]] = null;
    }

    isError = isError || showErrorMsg;
  })

  return {
    isError,
    errorMsg
  }
}
